import { forwardRef } from 'react';
import { SvgIcon } from '@material-ui/core';

export const MessagingBankIcon = forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 24 24"
    data-fill-none
  >
    <path
      d="M8.75 4.5H18.75C18.75 4.5 19.5 4.5 19.5 5.25V6.25C19.5 6.25 19.5 7 18.75 7H8.75C8.75 7 8 7 8 6.25V5.25C8 5.25 8 4.5 8.75 4.5Z"
      fill="currentColor"
    />
    <path
      d="M8.75 9H18.75C18.75 9 19.5 9 19.5 9.75V10.75C19.5 10.75 19.5 11.5 18.75 11.5H8.75C8.75 11.5 8 11.5 8 10.75V9.75C8 9.75 8 9 8.75 9Z"
      fill="currentColor"
    />
    <path
      d="M8.75 13.5H13.75C13.75 13.5 14.5 13.5 14.5 14.25V15.25C14.5 15.25 14.5 16 13.75 16H8.75C8.75 16 8 16 8 15.25V14.25C8 14.25 8 13.5 8.75 13.5Z"
      fill="currentColor"
    />
    <path
      d="M22 0H5.5C4.96957 0 4.46086 0.210714 4.08579 0.585786C3.71071 0.960859 3.5 1.46957 3.5 2V18.5C3.5 19.0304 3.71071 19.5391 4.08579 19.9142C4.46086 20.2893 4.96957 20.5 5.5 20.5H22C22.5304 20.5 23.0391 20.2893 23.4142 19.9142C23.7893 19.5391 24 19.0304 24 18.5V2C24 1.46957 23.7893 0.960859 23.4142 0.585786C23.0391 0.210714 22.5304 0 22 0ZM21.86 18.35C21.7624 18.4423 21.6343 18.4957 21.5 18.5H6C5.86739 18.5 5.74021 18.4473 5.64645 18.3536C5.55268 18.2598 5.5 18.1326 5.5 18V2.5C5.5 2.36739 5.55268 2.24021 5.64645 2.14645C5.74021 2.05268 5.86739 2 6 2H21.5C21.6326 2 21.7598 2.05268 21.8536 2.14645C21.9473 2.24021 22 2.36739 22 2.5V18C22.0008 18.1305 21.9505 18.2561 21.86 18.35Z"
      fill="currentColor"
    />
    <path
      d="M19.5 22H2.5C2.36739 22 2.24021 21.9473 2.14645 21.8536C2.05268 21.7598 2 21.6326 2 21.5V4.5C2 4.23478 1.89464 3.98043 1.70711 3.79289C1.51957 3.60536 1.26522 3.5 1 3.5C0.734784 3.5 0.48043 3.60536 0.292893 3.79289C0.105357 3.98043 0 4.23478 0 4.5L0 22C0 22.5304 0.210714 23.0391 0.585786 23.4142C0.960859 23.7893 1.46957 24 2 24H19.5C19.7652 24 20.0196 23.8946 20.2071 23.7071C20.3946 23.5196 20.5 23.2652 20.5 23C20.5 22.7348 20.3946 22.4804 20.2071 22.2929C20.0196 22.1054 19.7652 22 19.5 22Z"
      fill="currentColor"
    />
  </SvgIcon>
));
